import React from "react";
import "./CartAggsLayout.css";
import PosCustomIcon from "../PosCustomIcon/PosCustomIcon";
import vegIcon from "../../assets/images/veg-new.png";
import nonVegIcon from "../../assets/images/non-veg-new.png";
import { ArrowUturnLeftIcon, GiftIcon } from "@heroicons/react/24/outline";
import { getStoreCurrencySymbol } from "../../utils/currency";

const CartAggsLayout = ({
  foodType,
  productName,
  quantity,
  price,
  addonProduct,
  isReturned,
  isComplimentary,
  isBundle,
}) => {
  const addOnNames =
    addonProduct && addonProduct.length > 0
      ? addonProduct.map((addOn) => addOn.itemName).join(", ")
      : null;

  return (
    <div className="CartAggsLayoutContainer">
      <div className="cartAggsLayoutHeader">
        <div className="cartAggsLayoutHeaderText">
          <PosCustomIcon
            image={foodType === "VEG" ? vegIcon : nonVegIcon}
            height={"16px"}
            width={"16px"}
          />
          {isReturned && (
            <span className="cartAggsReturnedIcon" title="Returned">
              <ArrowUturnLeftIcon width={14} height={14} />
            </span>
          )}
          {isComplimentary && (
            <span className="cartAggsComplimentaryIcon" title="Complimentary">
              <GiftIcon width={14} height={14} />
            </span>
          )}
          {isBundle && (
            <span style={{ fontSize: "16px", lineHeight: "1" }} title="Combo">🍱</span>
          )}
          <p className="cartAggsPrimayText" title={productName}>
            {productName} <span className="cartAggsQuantity">x{quantity}</span>
          </p>
        </div>
        <p className="cartAggsPrimayText">{getStoreCurrencySymbol()}{price}</p>
      </div>
      <div className="cartAggsLayoutAddons">
        <p>{addOnNames}</p>
      </div>
    </div>
  );
};

export default CartAggsLayout;